import { useEffect } from 'react';

/**
 * Hook that triggers callback when user clicks outside given elements (can be more than one).
 * @param refs - one or more refs (useRef) to elements that we want to click outside of
 * @param callback - either use useCallback, or function defined outside of component render (so this hook is not called on every render)
 * @param predicate - (optional) event listener will only be registered if this is truthy value
 * (can be used to prevent unnecessary listener registrations for drop-down like components)
 */
export const useOutsideClick = (refs, callback, predicate = true) => {
    useEffect(() => {
        if (!predicate) {
            return () => {};
        }

        const isEventFromOutside = e => {
            return (
                e.target?.isConnected &&
                (Array.isArray(refs) ? refs : [refs]).reduce(
                    (isOutsideAll, ref) => isOutsideAll && ref.current && !ref.current.contains(e.target),
                    true
                )
            );
        };
        const handleClick = e => {
            if (isEventFromOutside(e)) {
                callback(e);
            }
        };

        document.addEventListener('mousedown', handleClick);
        return () => {
            document.addEventListener('mousedown', handleClick);
        };
    }, [refs, callback, predicate]);
};
